import * as React from 'react';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

import { ReactComponent as ChevronDownIcon } from 'component-lib/atoms/icon-v2/ChevronDownIcon.svg';

export const TableContainer = ({ children, ...forwardedProps }: React.ComponentPropsWithoutRef<'div'>) => {
  return (
    <div {...forwardedProps} tw="overflow-x-auto">
      <div tw="border-b-1 border-gray-15 border-t-1 min-w-min sm:(border-1 overflow-hidden rounded-sm)">{children}</div>
    </div>
  );
};

export const Table = tw.table`
  text-base
  w-full
  whitespace-nowrap
`;

export const TableHeader = tw.thead`
  bg-primary-lightest
  text-left
  text-primary
`;

export const TableBody = tw.tbody`
  bg-white
  text-primary-medium
`;

export const TableRow = styled.tr({
  'tbody > &': tw`
    border-gray-15
    border-t-1
  `,
});

export const TableCell = styled.td<{ $align?: 'left' | 'right'; as: 'td' | 'th'; canSort?: boolean }>(
  ({ $align = 'left', as, canSort }) => [
    tw`
    min-h-[3rem]
    px-2
    py-[0.75rem]

    first:pl-3
    last:pr-3

    sm:(first:pl-2 last:pr-2)
  `,
    $align === 'right' && tw`text-right`,
    as === 'th' &&
      tw`
      font-medium
      text-sm
    `,
    canSort && tw`cursor-pointer`,
  ],
);

export const TableChevron = styled(ChevronDownIcon)<{
  $sortDirection?: false | 'desc' | 'asc';
}>(({ $sortDirection }) => [
  tw`duration-fast ease-in-out inline-block ml-1 transition`,
  $sortDirection ? tw`text-primary` : tw`opacity-0 text-gray-50`,
  $sortDirection === 'asc' && tw`transform -rotate-180`,
  { 'th:hover &': tw`opacity-100` },
]);
